// TODO: Move this from utils to where it's needed
const parseAnalyticsTags = (tags = []) => {
  if (typeof tags === 'string'){ return ({}) }; // This is to catch legacy pageTag type causing an error when using reduce
  
  const analytics = tags?.reduce((acc, tag) => {
    let {key, value} = tag;
    
    return {
      ...acc,
      [key]: value,
    };
  }, {});

  return analytics;
};

export default parseAnalyticsTags;